import module from 'guest/module.js'

class GuestNominaDocumentoComprobanteService {
  constructor ($api) {
    this.$api = $api
  }

  link (idProyecto, idColaborador, idArchivo) {
    return this.$api.link('documentos/open', {
      folder: `${idColaborador}@${idProyecto}`,
      uid: `${idColaborador}@${idProyecto}`,
      id: idArchivo,
    })
  }
}

module.service('GuestNominaDocumentoComprobante', GuestNominaDocumentoComprobanteService)



// WEBPACK FOOTER //
// ./src/guest/services/Guest/Nomina/Documento/Comprobante.js